import { useState } from 'react';

import { useDrawdownRepaymentSchedule } from '@api/lendingAPI/lapiHooks';
import { IconAngleRight, IconCalendar } from '@iwoca/icons';
import { Button, Modal } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { TUseRCFWithdrawFunds } from './useRCFWithdrawFunds';
import { RCFRepaymentSchedule } from '../../../myOffers/approvedView/RCFApprovedView/RCFRepaymentSchedule/RCFRepaymentSchedule';
import { isSelectedAmountValidForAccessPeriod } from '../../../ui/ChooseAmountInputWithSlider/isSelectedAmountValid';

export const ViewNewPaymentPlan = ({
    newOutstandingBalance,
    drawdownAmount,
    accessPeriod
}: {
    newOutstandingBalance: number;
    drawdownAmount: number;
    accessPeriod: TUseRCFWithdrawFunds['formalOfferAccessPeriod'];
}) => {
    const [showPaymentPlan, setShowPaymentPlan] = useState(false);
    const { data } = useDrawdownRepaymentSchedule({
        offerId: accessPeriod.offer_id,
        drawdownAmount,
        enabled: isSelectedAmountValidForAccessPeriod(
            drawdownAmount,
            accessPeriod
        ),
        suspense: true
    });

    const repaymentSchedule = data!;

    return (
        <>
            <Modal
                isOpen={showPaymentPlan}
                onClose={() => setShowPaymentPlan(false)}
                closeIcon
            >
                <RCFRepaymentSchedule
                    newOutstandingBalance={newOutstandingBalance}
                    repaymentSchedule={repaymentSchedule}
                    isInRepaymentFreePeriod={true}
                />
            </Modal>

            <Button
                variant="tertiary"
                className="px-0"
                onClick={() => setShowPaymentPlan(true)}
            >
                <IconCalendar />
                <FormattedMessage
                    id="_.outstanding_view.rcf_view_new_payment_plan"
                    defaultMessage="View new payment plan"
                />
                <IconAngleRight />
            </Button>
        </>
    );
};
